export default __webpack_public_path__ + "media/images/upload-1e6706a6.svg";